import React from 'react';
import { Outlet } from 'react-router-dom';

const SPA = () => {
    return (
        <div className=''>
            <Outlet />
        </div>
    );
};




export default SPA;
